import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import Swal from "sweetalert2";
import Header from "./header";
import axios from "axios";
import Footer from "./footer";

export default function Shop() {
  const history = useHistory();
  const [products, setProducts] = useState([]);
  const [selectedOption, setSelectedOption] = useState([]);
  const [rentalStartDate, setRentalStartDate] = useState(new Date());
  const [rentalEndDate, setRentalEndDate] = useState(new Date());
  const [showOptions, setShowOptions] = useState(false); // New state to control visibility
  const [selectedAction, setSelectedAction] = useState(null);
  const [quantity, setQuantity] = useState(1);
  const [isInCart, setIsInCart] = useState(false); // New state
  const [cartItemDetails, setCartItemDetails] = useState(null); // New state
  const [cartProductIds, setCartProductIds] = useState([]);
  const [wishlistProductIds, setWishlistProductIds] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("");
  const [categories, setCategories] = useState([]);
  const [sortBy, setSortBy] = useState("name");
  const [sortOrder, setSortOrder] = useState("asc");
  const API_URL = "https://sunrise-backend.sunrisemeditechsystems.com/api";

  useEffect(() => {
    const token = localStorage.getItem("userToken");
    if (token) {
      axios
        .get(`${API_URL}/cart`, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((res) => {
          console.log("Cart API response:", res.data);
          // Handle both array of objects and array of strings
          let ids = [];
          if (Array.isArray(res.data.products)) {
            if (typeof res.data.products[0] === "object") {
              ids = res.data.products.map(
                (p) => p.productId?.toString?.() ?? p.toString()
              );
            } else {
              ids = res.data.products.map((p) => p.toString());
            }
          }
          setCartProductIds(ids);
        })
        .catch(() => setCartProductIds([]));
      axios
        .get(`${API_URL}/wishlist`, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((res) => {
          console.log("Wishlist API response:", res.data);
          let ids = [];
          if (Array.isArray(res.data.products)) {
            if (typeof res.data.products[0] === "object") {
              ids = res.data.products.map(
                (p) => p.productId?.toString?.() ?? p.toString()
              );
            } else {
              ids = res.data.products.map((p) => p.toString());
            }
          }
          setWishlistProductIds(ids);
        })
        .catch(() => setWishlistProductIds([]));
    }
  }, []);

  const fetchProducts = async () => {
    try {
      const response = await axios.get(
        `${API_URL}/products?search=${searchTerm}&category=${selectedCategory}&sortBy=${sortBy}&sortOrder=${sortOrder}`
      );
      setProducts(response.data);
    } catch (error) {
      // console.error("Failed to fetch products:", error);
      // setProducts([]);
    }
  };
  const fetchCategories = async () => {
    try {
      const response = await axios.get(`${API_URL}/categories`);
      setCategories(response.data);
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };
  useEffect(() => {
    fetchProducts();
    fetchCategories();
  }, [searchTerm, selectedCategory, sortBy, sortOrder]);

  const handleProductClick = (id) => {
    localStorage.setItem("product_id", id);
    history.push(`/view`);
  };

  const handleAddToWishlist = (id) => {
    const token = localStorage.getItem("userToken");
    if (!token) {
      Swal.fire(
        "Login Required",
        "Please login to proceed to wishlist.",
        "info"
      );
      return;
    }
    const product_details = products.find((product) => product.id === id);
    if (!product_details) return;
    if (selectedOption === "buy" && quantity > product_details.saleStock) {
      Swal.fire("Error", "Not enough stock available for purchase.", "error");
      return;
    }
    if (selectedOption === "rent" && product_details.rentalStock <= 0) {
      Swal.fire("Error", "Not enough stock available for rent.", "error");
      return;
    }

    const timeDiff = rentalEndDate.getTime() - rentalStartDate.getTime();
    const diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
    const rentalDays = diffDays > 0 ? diffDays : 1;

    const cartItem = {
      productId: product_details.id,
      name: product_details.name,
      price: product_details.salePrice,
      quantity: selectedOption === "buy" ? quantity : rentalDays,
      type: selectedOption,
      image: product_details.image,
    };

    if (selectedOption === "rent") {
      cartItem.rentalStartDate = rentalStartDate.toISOString();
      cartItem.rentalEndDate = rentalEndDate.toISOString();
    }

    //    // Get existing cart items from localStorage
    const userId = localStorage.getItem("currentUserId");
    const wishlistKey = `wishlist_${userId}`;
    const existingCart = JSON.parse(localStorage.getItem(wishlistKey) || "[]");

    //    // Check if item already exists in cart
    const existingItemIndex = existingCart.findIndex(
      (item) =>
        item.productId === cartItem.productId && item.type === cartItem.type
    );

    if (existingItemIndex > -1) {
      // Update quantity if item exists
      existingCart[existingItemIndex].quantity += cartItem.quantity;
    } else {
      // Add new item if it doesn't exist
      existingCart.push(cartItem);
    }

    //    // Save updated cart to localStorage
    const updatedCart = existingCart;
    localStorage.setItem(wishlistKey, JSON.stringify(updatedCart));
    window.dispatchEvent(new Event("cartUpdated")); // Dispatch event
    history.push("/wishlist"); // Navigate to wishlist page

    Swal.fire({
      title: "Success!",
      text: "Product added to wishlist",
      icon: "success",
      showConfirmButton: false,
      timer: 1500,
    });
    setShowOptions(false); // Hide options after adding to cart
    setQuantity(1); // Reset quantity
    setRentalStartDate(new Date());
    setRentalEndDate(new Date());
    setSelectedOption("buy"); // Reset option
    setSelectedAction(null); // Reset selected action
    setIsInCart(true); // Update cart status
    setCartItemDetails(cartItem); // Update cart item details
  };

  return (
    <>
      <div class="color-scheme-wrap active">
        <button class="switchIcon">
          <i class="fa-solid fa-palette"></i>
        </button>
        <h4 class="color-scheme-wrap-title">
          <i class="far fa-palette me-2"></i>Style Swicher
        </h4>
        <div class="color-switch-btns">
          <button data-color="#3E66F3">
            <i class="fa-solid fa-droplet"></i>
          </button>
          <button data-color="#684DF4">
            <i class="fa-solid fa-droplet"></i>
          </button>
          <button data-color="#008080">
            <i class="fa-solid fa-droplet"></i>
          </button>
          <button data-color="#323F7C">
            <i class="fa-solid fa-droplet"></i>
          </button>
          <button data-color="#FC3737">
            <i class="fa-solid fa-droplet"></i>
          </button>
          <button data-color="#8a2be2">
            <i class="fa-solid fa-droplet"></i>
          </button>
        </div>
        <Link
          to="https://themeforest.net/user/themeholy"
          class="th-btn text-center w-100"
        >
          <i class="fa fa-shopping-cart me-2"></i> Purchase
        </Link>
      </div>
      {/* Preloader */}
      {/* <div class="preloader ">
        <button class="th-btn preloaderCls">Cancel Preloader </button>
        <div class="preloader-inner">
          <img src="assets/img/logo.svg" alt="img" />
          <div class="heart-rate">
            <img src="assets/img/shape/preloader.svg" alt="" />

            <div class="fade-in"></div>

            <div class="fade-out"></div>
          </div>
        </div>
      </div> */}

      {/* Product Lightbox */}

      <div id="QuickView" class="white-popup mfp-hide">
        <div class="container bg-white">
          <div class="row gx-60">
            <div class="col-lg-6">
              <div class="product-big-img">
                <div class="img">
                  <img
                    src="assets/img/product/product_1_1.jpg"
                    alt="Product Image1"
                  />
                </div>
              </div>
            </div>
            <div class="col-lg-6 align-self-center">
              <div class="product-about">
                <p class="price">
                  $25.00 USD <del>$28.00 USD</del>
                </p>
                <h2 class="product-title">Fingertip Pulse Oximeter</h2>
                <div class="product-rating">
                  <div
                    class="star-rating"
                    role="img"
                    aria-label="Rated 5.00 out of 5"
                  >
                    <span style={{ width: "100%" }}>
                      Rated <strong class="rating">5.00</strong> out of 5 based
                      on <span class="rating">1</span> customer rating
                    </span>
                  </div>
                  <Link to="shop-details.html" class="woocommerce-review-link">
                    (<span class="count">3</span> customer reviews)
                  </Link>
                </div>
                <p class="text">
                  A device for measuring blood pressure is a medical device that
                  helps individuals monitor their blood pressure levels at home.
                  The user places the cuff on their arm, presses a button to
                  inflate it, and the device measures the pressure in the
                  arteries as the cuff slowly deflates.
                </p>
                <div class="checklist style4">
                  <ul>
                    <li>
                      {" "}
                      <i class="fa-regular fa-ship fa-fw"></i>Estimate delivery
                      times: 12-26 days (International), 3-6 days (United
                      States).
                    </li>
                    <li>
                      <i class="fa-solid fa-rotate-left"></i>Return within 7
                      days of purchase. Duties & taxes are non-refundable.
                    </li>
                  </ul>
                </div>
                <div class="actions">
                  <div class="quantity">
                    <input
                      type="number"
                      class="qty-input"
                      step="1"
                      min="1"
                      max="100"
                      name="quantity"
                      value="1"
                      title="Qty"
                    />
                    <button class="quantity-plus qty-btn">
                      <i class="far fa-chevron-up"></i>
                    </button>
                    <button class="quantity-minus qty-btn">
                      <i class="far fa-chevron-down"></i>
                    </button>
                  </div>
                  <button class="th-btn">Add to Cart</button>
                </div>
                <div class="product_meta">
                  <span class="sku_wrapper">
                    SKU: <span class="sku">Medical-1254</span>
                  </span>
                  <span class="posted_in">
                    Category:{" "}
                    <Link to="shop.html" rel="tag">
                      Device, Heatlhcare
                    </Link>
                  </span>
                  <span>
                    Tags:<Link to="shop.html">Medical Device</Link>
                  </span>
                  <span>
                    Availability:<Link to="shop.html">In Stock: 25</Link>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <button title="Close (Esc)" type="button" class="mfp-close">
            ×
          </button>
        </div>
      </div>
      {/* Sidemenu */}
      <div class="sidemenu-wrapper shopping-cart ">
        <div class="sidemenu-content">
          <button class="closeButton sideMenuCls">
            <i class="far fa-times"></i>
          </button>
          <div class="widget woocommerce widget_shopping_cart">
            <h3 class="widget_title">Shopping cart</h3>
            <div class="widget_shopping_cart_content">
              <ul class="woocommerce-mini-cart cart_list product_list_widget ">
                <li class="woocommerce-mini-cart-item mini_cart_item">
                  <Link to="#" class="remove remove_from_cart_button">
                    <i class="far fa-times"></i>
                  </Link>
                  <Link to="#">
                    <img
                      src="assets/img/product/product_thumb_1_1.jpg"
                      alt="Cart Image2"
                    />
                    Puregen Labs Meclizine
                  </Link>
                  <span class="quantity">
                    1 ×
                    <span class="woocommerce-Price-amount amount">
                      <span class="woocommerce-Price-currencySymbol">₹ </span>
                      ₹ 55.00
                    </span>
                  </span>
                </li>
                {/* <li class="woocommerce-mini-cart-item mini_cart_item">
                           <Link to="#" class="remove remove_from_cart_button"><i class="far fa-times"></i></Link>
                           <Link to="#"><img src="assets/img/product/product_thumb_1_2.jpg" alt="Cart Image"/>Pranarom Pure Essential Oil</Link>
                            <span class="quantity">1 ×
                                <span class="woocommerce-Price-amount amount">
                                    <span class="woocommerce-Price-currencySymbol">$</span>$15.00</span>
                            </span>
                        </li>
                        <li class="woocommerce-mini-cart-item mini_cart_item">
                           <Link to="#" class="remove remove_from_cart_button"><i class="far fa-times"></i></Link>
                           <Link to="#"><img src="assets/img/product/product_thumb_1_3.jpg" alt="Cart Image"/>Pediatric Stethoscope</Link>
                            <span class="quantity">1 ×
                                <span class="woocommerce-Price-amount amount">
                                    <span class="woocommerce-Price-currencySymbol">$</span>$30.00</span>
                            </span>
                        </li>
                        <li class="woocommerce-mini-cart-item mini_cart_item">
                           <Link to="#" class="remove remove_from_cart_button"><i class="far fa-times"></i></Link>
                           <Link to="#"><img src="assets/img/product/product_thumb_1_4.jpg" alt="Cart Image"/>Puregen Labs Allergy Relief</Link>
                            <span class="quantity">1 ×
                                <span class="woocommerce-Price-amount amount">
                                    <span class="woocommerce-Price-currencySymbol">$</span>$55.00</span>
                            </span>
                        </li>
                        <li class="woocommerce-mini-cart-item mini_cart_item">
                           <Link to="#" class="remove remove_from_cart_button"><i class="far fa-times"></i></Link>
                           <Link to="#"><img src="assets/img/product/product_thumb_1_5.jpg" alt="Cart Image"/>Digital Thermometer</Link>
                            <span class="quantity">1 ×
                                <span class="woocommerce-Price-amount amount">
                                    <span class="woocommerce-Price-currencySymbol">$</span>$15.99</span>
                            </span>
                        </li> */}
              </ul>
              <p class="woocommerce-mini-cart__total total">
                <strong>Subtotal:</strong>
                <span class="woocommerce-Price-amount amount">
                  <span class="woocommerce-Price-currencySymbol">₹ </span>170.99
                </span>
              </p>
              <p class="woocommerce-mini-cart__buttons buttons btn-wrap">
                <Link to="cart.html" class="th-btn wc-forward">
                  View cart
                </Link>
                <Link to="checkout.html" class="th-btn checkout wc-forward">
                  Checkout
                </Link>
              </p>
            </div>
          </div>
        </div>
      </div>
      {/* Sidemenu */}
      <div class="sidemenu-wrapper ">
        <div class="sidemenu-content">
          <button class="closeButton sideMenuCls">
            <i class="far fa-times"></i>
          </button>
          <div class="widget footer-widget mb-0">
            <div class="th-widget-about">
              <div class="about-logo">
                <Link to="/">
                  <img src="assets/img/logo.svg" alt="Medova " />
                </Link>
              </div>
              <p class="about-text">
                Medova is a convenience services to the adaptability, Spacious
                modern villa living room with centrally placed swimming pool
                blending indooroutdoor
              </p>
            </div>
          </div>
          <div class="widget footer-widget">
            <h3 class="widget_title">Recent Posts</h3>
            <div class="recent-post-wrap">
              <div class="recent-post">
                <div class="media-img">
                  <Link to="blog-details.html">
                    <img
                      src="assets/img/blog/recent-post-1-1.jpg"
                      alt="Blog Image2"
                    />
                  </Link>
                </div>
                <div class="media-body">
                  <div class="recent-post-meta">
                    <Link to="blog.html">
                      <i class="fa-sharp fa-solid fa-calendar-days"></i>April
                      02, 2025
                    </Link>
                  </div>
                  <h4 class="post-title">
                    <Link class="text-inherit" to="blog-details.html">
                      Cometes contabesco audacia aeneus tui canonicus
                    </Link>
                  </h4>
                </div>
              </div>
              <div class="recent-post">
                <div class="media-img">
                  <Link to="blog-details.html">
                    <img
                      src="assets/img/blog/recent-post-1-2.jpg"
                      alt="Blog Image5"
                    />
                  </Link>
                </div>
                <div class="media-body">
                  <div class="recent-post-meta">
                    <Link to="blog.html">
                      <i class="fa-sharp fa-solid fa-calendar-days"></i>April
                      25, 2025
                    </Link>
                  </div>
                  <h4 class="post-title">
                    <Link class="text-inherit" to="blog-details.html">
                      Cometes contabesco audacia aeneus tui canonicus
                    </Link>
                  </h4>
                </div>
              </div>
              <div class="recent-post">
                <div class="media-img">
                  <Link to="blog-details.html">
                    <img
                      src="assets/img/blog/recent-post-1-3.jpg"
                      alt="Blog Image8"
                    />
                  </Link>
                </div>
                <div class="media-body">
                  <div class="recent-post-meta">
                    <Link to="blog.html">
                      <i class="fa-sharp fa-solid fa-calendar-days"></i>26
                      April, 2025
                    </Link>
                  </div>
                  <h4 class="post-title">
                    <Link class="text-inherit" to="blog-details.html">
                      Cometes contabesco audacia aeneus tui canonicus
                    </Link>
                  </h4>
                </div>
              </div>
              <div class="recent-post">
                <div class="media-img">
                  <Link to="blog-details.html">
                    <img
                      src="assets/img/blog/recent-post-1-4.jpg"
                      alt="Blog Image11"
                    />
                  </Link>
                </div>
                <div class="media-body">
                  <div class="recent-post-meta">
                    <Link to="blog.html">
                      <i class="fa-sharp fa-solid fa-calendar-days"></i>27
                      April, 2025
                    </Link>
                  </div>
                  <h4 class="post-title">
                    <Link class="text-inherit" to="blog-details.html">
                      Cometes contabesco audacia aeneus tui canonicus
                    </Link>
                  </h4>
                </div>
              </div>
            </div>
          </div>
          <div class="widget footer-widget">
            <h3 class="widget_title">Social Media:</h3>
            <div class="th-social">
              <Link to="https://facebook.com">
                <i class="fab fa-facebook-f"></i>
              </Link>
              <Link to="https://twitter.com">
                <i class="fab fa-twitter"></i>
              </Link>
              <Link to="https://pinterest.com">
                <i class="fab fa-pinterest-p"></i>
              </Link>
              <Link to="https://linkedin.com">
                <i class="fab fa-linkedin-in"></i>
              </Link>
              <Link to="https://linkedin.com">
                <i class="fab fa-instagram"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>
      <div class="popup-search-box d-none d-lg-block">
        <button class="searchClose">
          <i class="fal fa-times"></i>
        </button>
        <form action="#">
          <input type="text" placeholder="What are you looking for?" />
          <button type="submit">
            <i class="fal fa-search"></i>
          </button>
        </form>
      </div>
      {/* Mobile Menu */}
      <div class="th-menu-wrapper">
        <div class="th-menu-area text-center">
          <button class="th-menu-toggle">
            <i class="fal fa-times"></i>
          </button>
          <div class="mobile-logo">
            <Link to="home-medical-clinic.html">
              <img src="assets/img/logo.svg" alt="Medova " />
            </Link>
          </div>

          <div class="th-mobile-menu">
            {/* <ul>
              <li class="menu-item-has-children">
                <Link to="home-medical-clinic.html">Home</Link>
                <ul class="sub-menu">
                  <li class="menu-item-has-children">
                    <Link to="#">Multipage</Link>
                    <ul>
                      <li>
                        <Link to="home-medical-clinic.html">
                          Home Medical Clinic
                        </Link>
                      </li>
                      <li>
                        <Link to="home-medical-clinic-v2.html">
                          Home Medical Clinic v2
                        </Link>
                      </li>
                      <li>
                        <Link to="home-dental-care.html">Home Dental Care</Link>
                      </li>
                      <li>
                        <Link to="home-pediatric.html">Home Pediatric</Link>
                      </li>
                      <li>
                        <Link to="home-cardiology.html">Home Cardiology</Link>
                      </li>
                      <li>
                        <Link to="home-surgery.html">Home Surgery</Link>
                      </li>
                      <li>
                        <Link to="home-physiotherapy.html">
                          Home Physiotherapy
                        </Link>
                      </li>
                      <li>
                        <Link to="home-nutrition-diet.html">
                          Home Nutrition Diet
                        </Link>
                      </li>
                      <li>
                        <Link to="home-optometrist.html">Home Optometrist</Link>
                      </li>
                      <li>
                        <Link to="home-medical-shop.html">
                          Home Medical Shop
                        </Link>
                      </li>
                    </ul>
                  </li>
                  <li class="menu-item-has-children">
                    <Link to="#">Onepage</Link>
                    <ul>
                      <li>
                        <Link to="home-medical-clinic-op.html">
                          Home Medical Clinic
                        </Link>
                      </li>
                      <li>
                        <Link to="home-medical-clinic-v2-op.html">
                          Home Medical Clinic v2
                        </Link>
                      </li>
                      <li>
                        <Link to="home-dental-care-op.html">
                          Home Dental Care
                        </Link>
                      </li>
                      <li>
                        <Link to="home-pediatric-op.html">Home Pediatric</Link>
                      </li>
                      <li>
                        <Link to="home-cardiology-op.html">
                          Home Cardiology
                        </Link>
                      </li>
                      <li>
                        <Link to="home-surgery-op.html">Home Surgery</Link>
                      </li>
                      <li>
                        <Link to="home-physiotherapy-op.html">
                          Home Physiotherapy
                        </Link>
                      </li>
                      <li>
                        <Link to="home-nutrition-diet-op.html">
                          Home Nutrition Diet
                        </Link>
                      </li>
                      <li>
                        <Link to="home-optometrist-op.html">
                          Home Optometrist
                        </Link>
                      </li>
                      <li>
                        <Link to="home-medical-shop-op.html">
                          Home Medical Shop
                        </Link>
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>
              <li>
                <Link to="about.html">About Us</Link>
              </li>
              <li class="menu-item-has-children">
                <Link to="#">Services</Link>
                <ul class="sub-menu">
                  <li>
                    <Link to="service.html">Services</Link>
                  </li>
                  <li>
                    <Link to="service-details.html">Service Details</Link>
                  </li>
                </ul>
              </li>
              <li class="menu-item-has-children">
                <Link to="#">Pages</Link>
                <ul class="sub-menu">
                  <li class="menu-item-has-children">
                    <Link to="#">Shop</Link>
                    <ul class="sub-menu">
                      <li>
                        <Link to="shop.html">Shop</Link>
                      </li>
                      <li>
                        <Link to="shop-details.html">Shop Details</Link>
                      </li>
                      <li>
                        <Link to="cart.html">Cart Page</Link>
                      </li>
                      <li>
                        <Link to="checkout.html">Checkout</Link>
                      </li>
                      <li>
                        <Link to="wishlist.html">Wishlist</Link>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <Link to="doctor.html">Doctors</Link>
                  </li>
                  <li>
                    <Link to="doctor-details.html">Doctors Details</Link>
                  </li>
                  <li>
                    <Link to="case-studies.html">Case Studies</Link>
                  </li>
                  <li>
                    <Link to="case-studies-details.html">
                      Case Studies Details
                    </Link>
                  </li>
                  <li>
                    <Link to="appointment.html">Appointment</Link>
                  </li>
                  <li>
                    <Link to="pricing.html">Price Table</Link>
                  </li>
                  <li>
                    <Link to="error.html">Error Page</Link>
                  </li>
                </ul>
              </li>
              <li class="menu-item-has-children">
                <Link to="#">Blog</Link>
                <ul class="sub-menu">
                  <li>
                    <Link to="#">Blog Layout</Link>
                    <ul class="sub-menu">
                      <li>
                        <Link to="blog.html">Blog</Link>
                      </li>
                      <li>
                        <Link to="blog-grid.html">Blog Grid</Link>
                      </li>
                      <li>
                        <Link to="blog-grid-sidebar.html">
                          Blog Grid With Sidebar
                        </Link>
                      </li>
                      <li>
                        <Link to="blog-list.html">Blog List</Link>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <Link to="blog-details.html">Blog Details</Link>
                  </li>
                </ul>
              </li>
            </ul> */}
          </div>
        </div>
      </div>
      {/* Header Area */}
      <Header />

      {/* Breadcumb */}

      <div
        class="breadcumb-wrapper "
        data-bg-src="assets/img/bg/breadcumb-bg.jpg"
      >
        <div class="container">
          <div class="breadcumb-content">
            <h1 class="breadcumb-title">Shop Page</h1>
            <ul class="breadcumb-menu">
              <li>
                <Link to="/">Home</Link>
              </li>
              <li>Shop Page</li>
            </ul>
          </div>
        </div>
      </div>

      {/* Product Area */}
      <section class="space-top space-extra-bottom">
        <div class="container">
          <div class="row justify-content-center">
            <div class="col-lg-6">
              <div class="title-area text-center">
                <span class="sub-title">shop products</span>
                <h2 class="sec-title">
                  We are Providing{" "}
                  <span class="fw-normal"> Supplies for Exceptional Care</span>
                </h2>
              </div>
            </div>
          </div>
          <div className="row mb-4">
            <div className="col-md-5">
              <div className="d-flex gap-3">
                <input
                  type="text"
                  className="form-control flex-grow-1"
                  placeholder="Search products..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  style={{ height: "50px" }}
                />
                <select
                  className="form-select flex-grow-1"
                  value={sortBy}
                  style={{ height: "50px" }}
                  onChange={(e) => {
                    const newSortBy = e.target.value;
                    if (newSortBy === sortBy) {
                      setSortOrder((prevOrder) =>
                        prevOrder === "asc" ? "desc" : "asc"
                      );
                    } else {
                      setSortOrder("asc");
                    }
                    setSortBy(newSortBy);
                  }}
                  name="sortBy"
                >
                  <option value="name">Sort by Name</option>
                  <option value="salePrice">Sort by Sale Price</option>
                  <option value="rentalPrice">Sort by Rental Price</option>
                </select>
                <select
                  className="form-select flex-grow-1"
                  value={selectedCategory}
                  onChange={(e) => setSelectedCategory(e.target.value)}
                  name="category"
                >
                  <option value="">All Categories</option>
                  {categories.map((category) => {
                    // ✅ safe logging
                    return (
                      <option key={category.id} value={category.name}>
                        {category.name}
                      </option>
                    );
                  })}
                </select>
              </div>
            </div>
          </div>

          <div class="row gy-4">
            {products.map((element) => {
              return (
                <div class="col-xl-4 col-md-6">
                  <div class="th-product product-grid">
                    <div class="product-img">
                      <img
                        src={`https://sunrise-backend.sunrisemeditechsystems.com${element.image}`}
                        alt="Product Image14"
                      />
                      <div class="actions">
                        <Link
                          to="#QuickView"
                          class="icon-btn popup-content"
                          onClick={(e) => {
                            e.preventDefault();
                            handleProductClick(element.id);
                          }}
                        >
                          <i class="far fa-eye"></i>
                        </Link>
                        <Link
                          to="#"
                          class="icon-btn"
                          onClick={(e) => {
                            e.preventDefault();
                            handleProductClick(element.id);
                          }}
                        >
                          <i class="far fa-cart-plus"></i>
                        </Link>
                        <Link
                          to="wishlist.html"
                          class="icon-btn"
                          onClick={(e) => {
                            e.preventDefault();
                            handleAddToWishlist(element.id, "wishlist");
                          }}
                        >
                          <i class="far fa-heart"></i>
                        </Link>
                      </div>
                    </div>
                    <div class="product-content">
                      <h3 class="product-title">
                        <Link
                          to="#"
                          onClick={(e) => {
                            e.preventDefault();
                            handleProductClick(element.id);
                          }}
                        >
                          {element.name}
                        </Link>
                      </h3>
                      <span class="price">₹ {element.salePrice}</span>
                      <div class="btn-group justify-content-between">
                        <Link
                          to="#"
                          class="th-btn"
                          onClick={(e) => {
                            e.preventDefault();
                            handleProductClick(element.id);
                          }}
                        >
                          ADD TO CART
                          <i class="fa-light fa-arrow-right-long ms-2"></i>
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>
      {/* Footer Area */}
      <Footer />
    </>
  );
}
